module.exports = __webpack_public_path__ + "img/accreditation.88cb1833.png";